import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from '../../ui/dialog'
import { Input } from '../../ui/input'
import { Button } from '../../ui/button'
export function GoalsConfigurationModal({ showGoalsModal, setShowGoalsModal, editingGoals, setEditingGoals, handleSaveGoals, isSavingGoals }: { showGoalsModal: boolean, setShowGoalsModal: (showGoalsModal: boolean) => void, editingGoals: any[], setEditingGoals: (editingGoals: any[]) => void, handleSaveGoals: () => void, isSavingGoals?: boolean }) {
    return (
        <Dialog open={showGoalsModal} onOpenChange={setShowGoalsModal}>
            <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-4xl">
                <DialogHeader>
                    <DialogTitle>Configurar Metas de Venta</DialogTitle>
                    <DialogDescription className="sr-only">
                        Configurar las metas diarias, mensuales y anuales de cada sucursal
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-6">
                    {editingGoals.map((goal, index) => (
                        <div
                            key={goal.branch}
                            className="rounded-lg border border-slate-200 p-4"
                        >
                            <h3 className="mb-4 font-semibold text-slate-900">
                                {goal.branch}
                            </h3>
                            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-slate-700">
                                        Meta Diaria
                                    </label>
                                    <Input
                                        type="number"
                                        value={goal.dailyGoal || ''}
                                        onChange={(e) => {
                                            const updated = [...editingGoals]
                                            updated[index] = { ...updated[index], dailyGoal: parseFloat(e.target.value) || 0 }
                                            setEditingGoals(updated)
                                        }}
                                        placeholder="0.00"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-slate-700">
                                        Meta Mensual
                                    </label>
                                    <Input
                                        type="number"
                                        value={goal.monthlyGoal || ''}
                                        onChange={(e) => {
                                            const updated = [...editingGoals]
                                            updated[index] = { ...updated[index], monthlyGoal: parseFloat(e.target.value) || 0 }
                                            setEditingGoals(updated)
                                        }}
                                        placeholder="0.00"
                                    />
                                </div>
                                <div className="space-y-2">
                                    <label className="text-sm font-medium text-slate-700">
                                        Meta Anual
                                    </label>
                                    <Input
                                        type="number"
                                        value={goal.annualGoal || ''}
                                        onChange={(e) => {
                                            const updated = [...editingGoals]
                                            updated[index] = { ...updated[index], annualGoal: parseFloat(e.target.value) || 0 }
                                            setEditingGoals(updated)
                                        }}
                                        placeholder="0.00"
                                    />
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="flex gap-3">
                        <Button onClick={handleSaveGoals} className="flex-1" size="lg" disabled={isSavingGoals}>
                            {isSavingGoals ? 'Guardando...' : 'Guardar Metas'}
                        </Button>
                        <Button
                            variant="outline"
                            onClick={() => setShowGoalsModal(false)}
                            className="flex-1"
                            size="lg"
                        >
                            Cancelar
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}